<template>
  <div class="d-flex flex-xs-row flex-xxs-column justify-content-between ">
    <div class="user-story-line shadow d-xs-flex d-xxs-none py-2 bg-white position-absolute" />
    <div class="d-flex flex-xs-column flex-xxs-row col-xxxs-12 col-sm-2 align-items-center justify-content-xs-center justify-content-xxs-start p-xs-0">
      <div class="bg-white rounded-circle p-3 shadow">
        <img src="@/assets/icons/cake.svg" height="50">
      </div>
      <span class="text-center mt-3 px-xs-0 px-xxs-3">
        {{ $t('UserProfile.UserStory.RegistrationInfo',{'month': userActivity.Month}) }}
      </span>
    </div>

    <div class="d-flex flex-xs-column flex-xxs-row col-xxxs-12 col-sm-2 align-items-center justify-content-xs-center justify-content-xxs-start p-xs-0 mt-xs-0 mt-xxs-5">
      <div class="bg-white rounded-circle p-3 shadow">
        <img src="@/assets/icons/android-logo.svg" height="50">
      </div>
      <span class="text-center mt-3 px-xs-0 px-xxs-3">
        {{ $t('UserProfile.UserStory.DownloadedAndroidGame',{'count': userActivity.DownloadedAndroidGameCount}) }}
      </span>
    </div>

    <div class="d-flex flex-xs-column flex-xxs-row col-xxxs-12 col-sm-2 align-items-center justify-content-xs-center justify-content-xxs-start p-xs-0 mt-xs-0 mt-xxs-5">
      <div class="bg-white rounded-circle p-3 shadow">
        <img src="@/assets/icons/html5.svg" height="50">
      </div>
      <span class="text-center mt-3 px-xs-0 px-xxs-3">
        {{ $t('UserProfile.UserStory.PlayedWebGames',{'count': userActivity.WebGameCount}) }}
      </span>
    </div>

    <div class="d-flex flex-xs-column flex-xxs-row col-xxxs-12 col-sm-2 align-items-center justify-content-xs-center justify-content-xxs-start p-xs-0 mt-xs-0 mt-xxs-5">
      <div class="bg-white rounded-circle p-3 shadow">
        <img src="@/assets/icons/dollar.svg" height="50">
      </div>
      <span class="text-center mt-3 px-xs-0 px-xxs-3">
        {{ $t('UserProfile.UserStory.SavedMoney',{'amount': userActivity.SavedAmount, 'priceType': userActivity.PriceType}) }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserProfileSubscribedUserStory',
  props: {
    userActivity: Object
  }
}
</script>
